import familyHttp from "./familyHttp";

const LOGIN_KEY = "familyIsLogin";
const USER_KEY = "familyUser";
const TOKEN_KEY = "familyToken";
const API_PREFIX = "/web/family/auth";

/** 一期演示固定验证码，与后端 family.auth.fixed-sms-code 保持一致 */
export const FAMILY_FIXED_SMS_CODE = "888888";

function maskMobile(mobile) {
  if (!mobile || mobile.length < 11) return mobile;
  return `${mobile.slice(0, 3)}****${mobile.slice(7)}`;
}

function unwrapResponse(res) {
  const body = res && res.data;
  if (!body || typeof body !== "object" || Array.isArray(body)) {
    return { ok: false, message: "服务无响应" };
  }
  if (body.success || body.code === 1) {
    return { ok: true, data: body.data, message: body.msg };
  }
  return { ok: false, message: body.msg || "请求失败" };
}

export const familyAuth = {
  isLoggedIn() {
    return (
      sessionStorage.getItem(LOGIN_KEY) === "true" &&
      !!sessionStorage.getItem(USER_KEY) &&
      !!sessionStorage.getItem(TOKEN_KEY)
    );
  },

  getUser() {
    try {
      return JSON.parse(sessionStorage.getItem(USER_KEY) || "null");
    } catch (e) {
      return null;
    }
  },

  getToken() {
    return sessionStorage.getItem(TOKEN_KEY);
  },

  setSession(user, token) {
    if (!user || !token) {
      throw new Error("登录响应异常，缺少用户信息或 token");
    }
    sessionStorage.setItem(LOGIN_KEY, "true");
    sessionStorage.setItem(TOKEN_KEY, token);
    sessionStorage.setItem(
      USER_KEY,
      JSON.stringify({
        id: user.id,
        mobile: user.mobile,
        nickname: user.nickname || `用户${(user.mobile || "").slice(-4)}`,
        mobileMasked: user.mobileMasked || maskMobile(user.mobile),
        avatar: user.avatar,
        profileBg: user.profileBg,
      })
    );
  },

  patchLocalUser(patch) {
    const user = this.getUser();
    if (!user) return;
    const next = { ...user, ...patch };
    sessionStorage.setItem(USER_KEY, JSON.stringify(next));
  },

  logout() {
    sessionStorage.removeItem(LOGIN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
  },

  async sendSmsCode(mobile) {
    const res = await familyHttp.post(`${API_PREFIX}/sms/send`, { mobile });
    const result = unwrapResponse(res);
    if (!result.ok) {
      throw new Error(result.message);
    }
    return FAMILY_FIXED_SMS_CODE;
  },

  async register({ mobile, smsCode, nickname, password }) {
    const res = await familyHttp.post(`${API_PREFIX}/register`, {
      mobile,
      smsCode,
      nickname,
      password,
    });
    const result = unwrapResponse(res);
    if (!result.ok) {
      return { ok: false, message: result.message };
    }
    const { user, token } = result.data || {};
    this.setSession(user, token);
    return { ok: true };
  },

  async login(mobile, password) {
    const res = await familyHttp.post(`${API_PREFIX}/login`, { mobile, password });
    const result = unwrapResponse(res);
    if (!result.ok) {
      throw new Error(result.message || "手机号或密码错误");
    }
    const { user, token } = result.data || {};
    this.setSession(user, token);
    return user;
  },
};
